import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { GatsbyBrowser } from "gatsby";

import "./src/styles/global.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 1000 * 60 * 5 },
  },
});

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => <QueryClientProvider client={queryClient}>{element}</QueryClientProvider>;

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => <>{element}</>;

const scrollToPageTop = () => {
  const root = document.documentElement;
  const previousScrollBehavior = root.style.scrollBehavior;

  root.style.scrollBehavior = "auto";
  window.scrollTo(0, 0);

  window.requestAnimationFrame(() => {
    root.style.scrollBehavior = previousScrollBehavior;
  });
};

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({
  routerProps,
}) => {
  if (routerProps.location.pathname.startsWith("/video/")) {
    scrollToPageTop();
    return false;
  }

  return true;
};
